import React from "react";
import styled from "styled-components";
import { CheckboxDescription, FooterNote, SettingsInputItem } from "../../Common/Components/FormComponents";
import { Section as UnstyledSection } from "../../Common/Styles/containers";

import Checkbox from "../../../components/pages/CourseAuthor/Checkbox";

const Section = styled(UnstyledSection)`
  display: flex;
  flex-direction: column;
`;
interface IBrandingAndReviewProps {
  allowCourseReview: boolean;
  includeBranding: boolean;
  toggleAllowCourseReview: (ev: React.MouseEvent<HTMLInputElement>) => void;
  toggleIncludeBranding: (ev: React.MouseEvent<HTMLInputElement>) => void;
}
function BrandingAndReview(props: IBrandingAndReviewProps) {
  return (
    <Section>
      <SettingsInputItem>
        <label>
          <Checkbox defaultChecked={props.includeBranding} onChange={props.toggleIncludeBranding} />
          <CheckboxDescription>Include Adaptive by Salt branding</CheckboxDescription>
        </label>
      </SettingsInputItem>
      <p>
        <FooterNote>
          If checked, a small message reading "A course by ADAPTIVE" will be added to the footer of the course
          completion page.
        </FooterNote>
      </p>
      <SettingsInputItem>
        <label>
          <Checkbox defaultChecked={props.allowCourseReview} onChange={props.toggleAllowCourseReview} />
          <CheckboxDescription>Allow Course Review</CheckboxDescription>
        </label>
      </SettingsInputItem>
      <p>
        <FooterNote>
          If checked, the learner will be able to re-enter the course after it is complete to review the materials.
        </FooterNote>
      </p>
    </Section>
  );
}

export default BrandingAndReview;
